var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.586 2.66675H10.4127C5.55935 2.66675 2.66602 5.56008 2.66602 10.4134V21.5734C2.66602 26.4401 5.55935 29.3334 10.4127 29.3334H21.5727C26.426 29.3334 29.3193 26.4401 29.3193 21.5868V10.4134C29.3327 5.56008 26.4394 2.66675 21.586 2.66675Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1863 10.8133C19.2129 8.85326 16.0129 8.85326 14.0529 10.8133C12.6796 12.1733 12.2663 14.1466 12.7996 15.8799L9.66627 19.0133C9.45294 19.2399 9.29294 19.6799 9.34627 19.9999L9.54627 21.4533C9.61294 21.9333 10.0663 22.3866 10.5463 22.4533L11.9996 22.6666C12.3196 22.7066 12.7596 22.5733 12.9863 22.3333L13.5329 21.7866C13.6663 21.6666 13.6663 21.4533 13.5329 21.3199L12.2396 20.0266C12.0529 19.8399 12.0529 19.5199 12.2396 19.3199C12.4263 19.1333 12.7463 19.1333 12.9463 19.3199L14.2396 20.6133C14.3596 20.7333 14.5729 20.7333 14.7063 20.6133L16.1196 19.2133C17.8396 19.7466 19.8129 19.3333 21.1863 17.9733C23.1596 15.9866 23.1596 12.7866 21.1863 10.8133ZM17.6663 15.9999C16.7463 15.9999 15.9996 15.2533 15.9996 14.3333C15.9996 13.4133 16.7463 12.6666 17.6663 12.6666C18.5863 12.6666 19.3329 13.4133 19.3329 14.3333C19.3329 15.2533 18.5863 15.9999 17.6663 15.9999Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStake);
export default __webpack_public_path__ + "static/media/stake.875465a26eb99e6ff1b520e86fc7696f.svg";
export { ForwardRef as ReactComponent };